export const fetchCurrentDashboard = async () => {
  return await window.$vue.$get({
    endpoint: "/dashboards/current"
  })
}
